import React from 'react';
import { useTranslation } from 'react-i18next';
import { ILiliPlanHighlightSection } from '../../types';
import { STYLES, TEXT } from '../../constants';
import Heading from '../../../../generic-components/Heading';
import { ReactComponent as CheckMarkIcon } from '../../../../assets/icons/svg/shared/ic-shared-checkmark.svg';

interface IProps{
    id: number
    section: ILiliPlanHighlightSection
}
export const LiliPlanHighlightSectionView = ({ section, id }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className='mb-[20px]' key={id}>
      <Heading
        title={section.title || ''}
        className={STYLES.INDEX.PLAN_PICKER.PLAN.HIGHLIGHT_SECTION_TITLE}
      />
      {section.highlights?.map((highlight) => (
        <div className={highlight.description !== undefined ? 'mt-[0px]' : 'mt-[0px]'}>
          <div className='flex flex-row'>
            <div className='min-w-[6px] mr-[6px]'>
              <CheckMarkIcon className={`${STYLES.INDEX.PLAN_PICKER.PLAN.CHECKMARK} text-bw08`} />
            </div>
            <p className='leading-7'>
              {
                  highlight.isNew ? <span className={STYLES.INDEX.PLAN_PICKER.PLAN.HIGHLIGHT_ROW_NEW_BADGE}>{t(TEXT.PLAN_PICKER.NEW_BADGE)}</span> : ''
              }
              <span className={STYLES.INDEX.PLAN_PICKER.PLAN.HIGHLIGHT_ROW_TITLE}>
                {highlight.title}
              </span>
              <span className={STYLES.INDEX.PLAN_PICKER.PLAN.HIGHLIGHT_ROW_DESCRIPTION}>{highlight.description}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
